import './scss/custom.scss';
import 'bootstrap';
import Vue from 'vue';
import i18n from "./i18n/i18n";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const router = new VueRouter({
});
import Login from "./components/Login.vue";

const app = new Vue({
    el: '#app',
    i18n,
    router,
    components: {Login},
    template: '<Login/>'
});
